import { IEventAttributeDetailsDTO } from '../../../../../../../api/attributes.dao';
import {
    HubModuleType,
    THubModuleDTO,
} from '../../../../../../../api/event-hubs.dao';
import { HubModuleVM } from './hub-module.viewmodel';
import { EventsModuleVM } from './_events-module/events-module.viewmodel';
import { SpeakersModuleVM } from './_speakers-module/speakers-module.viewmodel';
import { RichTextModuleVM } from './_rich-text-module/rich-text-module.viewmodel';
import { MyEventsModuleVM } from './_my-events-module/my-events-module.viewmodel';

export interface IHubModuleOptions {
    eventAttributeOptions: IEventAttributeDetailsDTO[];
}

const assertNever = (value: never): never => {
    throw new Error(`Unhandled HubModuleType: ${value as string}`);
};

export const createEmptyModule = (
    type: HubModuleType,
    positionOrder: number,
    options: IHubModuleOptions,
): HubModuleVM => {
    switch (type) {
        case HubModuleType.EVENTS:
            return EventsModuleVM.createEmpty(positionOrder, options.eventAttributeOptions);
        case HubModuleType.SPEAKERS:
            return SpeakersModuleVM.createEmpty(positionOrder);
        case HubModuleType.RICH_TEXT:
            return RichTextModuleVM.createEmpty(positionOrder);
        case HubModuleType.MY_EVENTS:
            return MyEventsModuleVM.createEmpty(positionOrder);
        default:
            return assertNever(type);
    }
};

export const createModuleFromDTO = (
    dto: THubModuleDTO,
    options: IHubModuleOptions,
): HubModuleVM => {
    switch (dto.moduleType) {
        case HubModuleType.EVENTS:
            return EventsModuleVM.createFromDTO(dto, options.eventAttributeOptions);
        case HubModuleType.SPEAKERS:
            return SpeakersModuleVM.createFromDTO(dto);
        case HubModuleType.RICH_TEXT:
            return RichTextModuleVM.createFromDTO(dto);
        case HubModuleType.MY_EVENTS:
            return MyEventsModuleVM.createFromDTO(dto);
        default:
            return assertNever(dto);
    }
};
